import { StoreAction, XmAction } from 'store/actions';
import { NowEsimActivation } from './models/activation';
import { NowEsimActivationStatus } from './models/activation-status';

export function nowEsimActivationReducer(state: NowEsimActivation, action: XmAction<NowEsimActivation>): NowEsimActivation {
    switch (action.type) {
        case StoreAction.GET_NOW_ESIM_ACTIVATION:
            return action.payload;
        default:
            return state;
    }
}

export function nowEsimActivationStatusReducer(state: NowEsimActivationStatus, action: XmAction<NowEsimActivationStatus>): NowEsimActivationStatus {
    switch (action.type) {
        case StoreAction.GET_NOW_ESIM_ACTIVATION_STATUS:
            return action.payload;
        default:
            return state;
    }
}
